import { createEffect } from 'effector';
import _ from 'lodash';
import $$ep from 'models/ep';
import { $currentQuestionPath, setCurrentQuestionPath } from 'models/light-engine-model';

import EstatePlanService from 'services/EstatePlanService';

const expressions = require('angular-expressions');

const LightEngineService = {
    getCurrentQuestionPath: (): string | null => {
        return $currentQuestionPath.getState();
    },

    setCurrentQuestionPath: (path: string) => {
        setCurrentQuestionPath(path);
    },

    getPrevQuestionPath: (): string | undefined => {
        const currentQuestionPath = LightEngineService.getCurrentQuestionPath();
        if (currentQuestionPath === null) {
            return undefined;
        }
        const firstAssessmentGroupPaths = EstatePlanService.getFirstAssessmentGroupPaths();
        return firstAssessmentGroupPaths[firstAssessmentGroupPaths.indexOf(currentQuestionPath) - 1];
    },

    getNextQuestionPath: (): string => {
        const currentQuestionPath = LightEngineService.getCurrentQuestionPath();
        if (currentQuestionPath === null) {
            return EstatePlanService.getFirstAssessmentGroupPaths()[0];
        }
        const firstAssessmentGroupPaths = EstatePlanService.getFirstAssessmentGroupPaths();
        return firstAssessmentGroupPaths[firstAssessmentGroupPaths.indexOf(currentQuestionPath) + 1];
    },

    isCanGoBack: () => {
        const prevQuestionPath = LightEngineService.getPrevQuestionPath();
        return prevQuestionPath !== undefined;
    },

    isCanGoForward: () => {
        const currentQuestionPath = LightEngineService.getCurrentQuestionPath();
        if (currentQuestionPath === null) {
            return false;
        }
        const currentQuestionAnswer = EstatePlanService.getAnswerByPath(currentQuestionPath);
        return !_.isEmpty(currentQuestionAnswer) || _.isBoolean(currentQuestionAnswer);
    },

    goBack: createEffect(() => {
        console.log(
            'goBack',
            LightEngineService.getCurrentQuestionPath(),
            EstatePlanService.getFirstAssessmentGroupPaths(),
        );
        const prevQuestionPath = LightEngineService.getPrevQuestionPath();
        if (prevQuestionPath !== undefined) {
            LightEngineService.setCurrentQuestionPath(prevQuestionPath);
        }
    }),

    goForward: createEffect(() => {
        console.log(
            'goForward',
            LightEngineService.getCurrentQuestionPath(),
            EstatePlanService.getFirstAssessmentGroupPaths(),
        );
        const nextQuestionPath = LightEngineService.getNextQuestionPath();
        if (nextQuestionPath !== undefined) {
            LightEngineService.setCurrentQuestionPath(nextQuestionPath);
        }
    }),

    setCurrentQuestionAnswer: createEffect((value: any) => {
        const currentQuestionPath = LightEngineService.getCurrentQuestionPath();
        if (currentQuestionPath === null) {
            return;
        }
        EstatePlanService.setQuestionAnswerByPath(currentQuestionPath, value);
    }),

    eval: (expression: string) => {
        try {
            const answers = $$ep.stores.$epAnswers.getState();
            return expressions.compile(expression.replace(/{{ /g, '').replace(/ }}/g, ''))(answers) || expression;
        } catch (e) {
            return expression;
        }
    },

    isQuestionVisible: (path: string): boolean => {
        const questionnaire = EstatePlanService.getQuestionnaire();
        const condition = _.get(questionnaire, `${path}._on`);
        if (!condition) {
            return true;
        }
        return LightEngineService.eval(condition) === true;
    },
};

export default LightEngineService;
